import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Box,
  Button,
  CardMedia,
  Container,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
  Card,
  CardContent,
  Chip,
  Stack,
  Avatar,
  CardActionArea,
} from "@mui/material";
import {
  Add as AddIcon,
  Remove as RemoveIcon,
  ShoppingCart as ShoppingCartIcon,
  Favorite as FavoriteIcon,
  FavoriteBorder as FavoriteBorderIcon,
  ChevronLeft,
  ChevronRight as ChevronRightIcon,
  Description as DescriptionIcon,
  Security as SecurityIcon,
  PhoneIphone as PhoneIphoneIcon,
  Star as StarIcon,
} from "@mui/icons-material";

import Images, {
  AppMock1,
  AppMock2,
  AppMock3,
  AppMock4,
  Cart,
  Search,
} from "assets/images/Images";
import Colors from "assets/style/Colors";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/swiper-bundle.min.css";
import { useTranslation } from "react-i18next";
import { useLanguage } from "context/UseContext";
import Video from "components/video/Video";
import ProductServices from "apis/product/ProductServices";
import { ErrorToaster, SuccessToaster } from "components/toaster/Toaster";
import { Star } from "@mui/icons-material";
import { useMediaQuery, useTheme } from "@mui/material";
import PharmacyServices from "apis/pharmacy/PharmacyServices";
import { BaseUrl } from "../../axios";
import CategoryServices from "apis/category/CategoryServices";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeToCart } from "redux/slices/cartDataSlice";
import Helmet from "react-helmet";

// const products = [
//   {
//     id: 1,
//     name: "PANADOL MIGRANE 250 mg,250 mg,65 mg 24s",
//     image: Images.panadol,
//     discount: 49,
//     originalPrice: 40.34,
//     salePrice: 33.0,
//     freeDelivery: true,
//     isFavorite: true,
//   },
//   {
//     id: 2,
//     name: "Nestle Peptamen Powder 430 G",
//     image: Images.panadol,
//     discount: null,
//     originalPrice: null,
//     salePrice: 120.34,
//     freeDelivery: true,
//     isFavorite: false,
//   },
//   {
//     id: 3,
//     name: "Regaine Foam 5% For Men 3x 73ml Offer Pack",
//     image: Images.panadol,
//     discount: 20,
//     originalPrice: 40.34,
//     salePrice: 33.0,
//     freeDelivery: false,
//     isFavorite: false,
//   },
//   {
//     id: 4,
//     name: "Babyvita Banana Jar 300 Gm",
//     image: Images.panadol,
//     discount: 50,
//     originalPrice: 36.0,
//     salePrice: 18.0,
//     freeDelivery: false,
//     isFavorite: false,
//   },
//   {
//     id: 5,
//     name: "N+ Spf 60 Sun Screen Matte Cream (50 Ml)",
//     image: Images.panadol,
//     discount: 30,
//     originalPrice: 36.0,
//     salePrice: 25.0,
//     freeDelivery: false,
//     isFavorite: false,
//   },
//   {
//     id: 6,
//     name: "Vitamin D3 Tablets 1000 IU",
//     image: Images.panadol,
//     discount: 25,
//     originalPrice: 45.0,
//     salePrice: 33.75,
//     freeDelivery: true,
//     isFavorite: false,
//   },
//   {
//     id: 7,
//     name: "Omega 3 Fish Oil Capsules",
//     image: Images.panadol,
//     discount: 15,
//     originalPrice: 60.0,
//     salePrice: 51.0,
//     freeDelivery: false,
//     isFavorite: false,
//   },
// ];
// const pharmicies = [
//   {
//     id: 1,
//     image: Images.dummyImg1,
//   },
//   {
//     id: 2,
//     image: Images.dummyImg2,
//   },
//   {
//     id: 3,
//     image: Images.dummyImg3,
//   },
//   {
//     id: 4,
//     image: Images.dummyImg4,
//   },
//   {
//     id: 5,
//     image: Images.dummyImg5,
//   },
//   {
//     id: 6,
//     image: Images.dummyImg6,
//   },
// ];

function Home() {
  const { t } = useTranslation();
  const { lang } = useLanguage();
  const appDownloadRef = useRef();
  const [searchText, setSearchText] = useState("");
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(0);

  const [pharmacies, setPharmacies] = useState([]);
  const [products, setProducts] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const [categories, setCategories] = useState([]);
  const [pharmacyLoading, setPharmacyLoading] = useState(false);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [productLoading, setProductLoading] = useState(false);
  const navigate = useNavigate();
  const { cart } = useSelector((state) => state.cartDataReducer);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleSearch = async () => {
    try {
      let params = {
        limit: 30,
        page: 1,
        search: searchText ? searchText : "",
      };
      const { data } = await ProductServices.getProducts(params);
      if (data?.result?.length !== 0) {
        navigate("/web/marketplace/products", {
          state: {
            data: data?.result,
            count: data?.count,
            searchText: searchText,
          },
        });
      } else {
        ErrorToaster("No Products Found");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleScroll = () => {
    try {
      appDownloadRef.current?.scrollIntoView({ behavior: "smooth" });
    } catch (error) {
      console.log("file: index.js:24 => handleScroll => error:", error);
    }
  };

  // const categories = [
  //   {
  //     label: "Healthy Food",
  //     image: Images.prod1,
  //   },
  //   {
  //     label: "Heart Care",
  //     image: Images.prod1,
  //   },
  //   {
  //     label: "Healthy Food",
  //     image: Images.prod1,
  //   },
  //   {
  //     label: "Heart Care",
  //     image: Images.prod1,
  //   },
  //   {
  //     label: "Healthy Food",
  //     image: Images.prod1,
  //   },
  //   {
  //     label: "Heart Care",
  //     image: Images.prod1,
  //   },
  // ];
  const features = [
    {
      id: 1,
      icon: <AppMock1 />,
      title: t("prescriptionUpload"),
      description: t("desc1"),
    },
    {
      id: 2,
      icon: <AppMock2 />,

      title: t("pharmacyProduct"),
      description: t("desc2"),
    },
    {
      id: 3,
      icon: <AppMock3 />,

      title: t("secureTransaction"),
      description: t("desc3"),
    },
    {
      id: 4,
      icon: <AppMock4 />,

      title: t("userFriendly"),
      description: t("desc4"),
    },
  ];
  const testimonials = [
    {
      id: 2,
      name: "Sarah Johnson",

      review:
        "I searched all the pharmacies here in Abu Dhabi for this particular medicine and none of them had it, you people responded on time and delivered on time as well, thanks.",
      rating: 5,
      date: "1 July 2022",
    },
    {
      id: 3,
      name: "Eden James",

      review:
        " Excellent service I bought medicine online from them.It was so fast delivery and the behaviour of the person was  also good. Its really preferable to everyone.",
      rating: 5,
      date: "10 March 2022",
    },
    {
      id: 4,
      name: "Emily Davis",

      review:
        "الفكرة رائعة والتواصل سهل والخدمة ممتازة وسرعة الرد  والإجابة على الاستفسارات تبرد على القلب والله ما أبالغ من  كل قلبي هالكلام، بارك الله في جهودكم وتستاهلون الخمس نجوم 👏",
      rating: 5,
      date: "18 December 2023",
    },
  ];
  const handlePharmacyClick = (pharmacyId, pharmacyName, pharmacyPicture) => {
    setSearchParams({
      pharmacy_id: pharmacyId,
      filter_by: "pharmacy",
    });
    navigate(
      `/web/marketplace/products?pharmacy_id=${pharmacyId}&filter_by=pharmacy`,
      {
        state: { pharmacyName, pharmacyPicture },
        replace: true,
      }
    );
  };
  const handleCategoryClick = (categoryId, categoryName, categoryPicture) => {
    setSearchParams({ category_id: categoryId, filter_by: "category" });
    navigate(
      `/web/marketplace/products?category_id=${categoryId}&filter_by=category`,
      {
        state: { categoryName, categoryPicture },
        replace: true,
      }
    );
  };
  const handleIncrement1 = (item) => {
    let data = {
      ...item,
      qty: cart.find((e) => e._id === item?._id)?.qty,
    };
    dispatch(addToCart(data));
    setQuantity((prev) => prev + 1);
    SuccessToaster("Product Add Successfully");
  };
  const handleIncrement = (item) => {
    let data = {
      ...item,
      qty: cart.find((e) => e._id === item?._id)?.qty,
    };
    dispatch(addToCart(data));
    setQuantity((prev) => prev + 1);
  };

  const handleDecrement = (item) => {
    let data = {
      ...item,
      qty: cart.find((e) => e._id === item?._id)?.qty,
    };
    dispatch(removeToCart(data));
    setQuantity((prev) => prev - 1);
  };

  // useEffect(() => {
  //   setQuantity(data.qty);
  // }, [data]);

  const getPharmacies = async () => {
    setPharmacyLoading(true);
    try {
      let params = {
        limit: 6,
        page: 1,
      };
      const { data } = await PharmacyServices.getPharmacies(params);
      setPharmacies(data?.result);
    } catch (error) {
      ErrorToaster(lang === "ar" ? error?.messageAr : error?.message);
    } finally {
      setPharmacyLoading(false);
    }
  };
  const getCategories = async () => {
    setCategoryLoading(true);
    try {
      let params = {
        limit: 6,
        page: 1,
      };
      const { data } = await CategoryServices.getCategories(params);
      setCategories(data?.result);
    } catch (error) {
      ErrorToaster(lang === "ar" ? error?.messageAr : error?.message);
    } finally {
      setCategoryLoading(false);
    }
  };
  const getProducts = async () => {
    setProductLoading(true);
    try {
      let params = {
        limit: 10,
        page: 1,
      };
      const { data } = await ProductServices.getProducts(params);
      setProducts(data?.result);
    } catch (error) {
      ErrorToaster(lang === "ar" ? error?.messageAr : error?.message);
    } finally {
      setProductLoading(false);
    }
  };

  useEffect(() => {
    getCategories();
    getPharmacies();
    getProducts();
  }, []);
  return (
    <Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          DOH-Licensed Telepharmacy | Upload & Order Medicines Online
        </title>
        <meta
          name="description"
          content="_Shop online at UAE's best DOH-Licensed tele pharmacy. Affordable prices,
    secure checkout, pharmacist support and fast home delivery across the UAE._"
        />
        <link rel="canonical" href="https://e-rx.info/" />
      </Helmet>
      {/* ========== Banner ========== */}

      {isSmallScreen ? (
        <Box
          sx={{
            minHeight: "100vh",
            direction: lang === "ar" ? "rtl" : "ltr",
            px: 2,
            pt: 12,
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <Box
              sx={{
                width: { md: "50%", xs: "100%" },
                height: "40px",
                backgroundColor: "#F7F7F7",
                // zIndex: "1",
                bottom: { md: "2%", xs: "27%" },
                p: 1,
                display: "flex",
                alignItems: "center",

                borderRadius: "10px",
              }}
            >
              <TextField
                size="medium"
                variant="outlined"
                type="text"
                fullWidth
                placeholder={t("SearchMedicines")}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
                sx={{
                  "& fieldset": { border: "none" },
                  "& input": {
                    pt: "5px",
                    pb: "5px",
                    pl: "14px",
                  },
                  "& .MuiInputBase-root": {
                    pr: "6px",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <Button
                      variant="contained"
                      sx={{ background: "none !important", boxShadow: "none" }}
                      onClick={handleSearch}
                      startIcon={<Search />}
                    ></Button>
                  ),
                }}
              />
            </Box>
          </Box>
          <Box sx={{ position: "relative", width: "100%" }}>
            <CardMedia
              image={Images.heroo3}
              sx={{
                width: "100%",
                borderRadius: 2,
                height: { sm: "400px", xs: "220px" },
                backgroundSize: { sm: "cover", xs: "cover" },
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            />

            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                px: { xs: 1, sm: 2 },
                py: { xs: 2, sm: 4 },
              }}
            >
              <Grid container>
                <Grid item xs={8}>
                  <Box
                    sx={{
                      borderRadius: 2,
                      p: { xs: 1, sm: 3 },
                    }}
                  >
                    <Box sx={{ mb: 2 }}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        sx={{
                          justifyContent: lang == "ar" ? "center" : "",
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          {[1, 2, 3, 4, 5].map((star) => (
                            <StarIcon
                              key={star}
                              sx={{
                                color: "#FFA826",
                                fontSize: { xs: "16px", md: "18px" },
                                "@media (max-width:444px)": {
                                  fontSize: "14px !important",
                                },
                              }}
                            />
                          ))}
                        </Box>
                        <Typography
                          variant="body2"
                          sx={{
                            color: Colors.black,
                            fontSize: { xs: "10px", sm: "12px" },
                            fontWeight: 500,
                          }}
                        >
                          1k+ {t("1k_download_worldWide")}
                        </Typography>
                      </Stack>
                    </Box>

                    <Typography
                      variant="h1"
                      sx={{
                        fontSize: { xs: "18px", sm: "29px", md: "28px" },
                        fontWeight: 600,
                        color: Colors.tertiary,
                        lineHeight: 1.2,
                        mb: 1.5,
                        textTransform: "uppercase",
                        justifyContent: lang == "ar" ? "center" : "",
                        display: lang == "ar" ? "flex" : "",
                        letterSpacing: "1px",
                        textAlign: lang == "ar" ? "center" : "left",
                        "@media (max-width:444px)": {
                          fontSize: "13px !important",
                        },
                      }}
                    >
                      {t("deliver")}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: "11px", sm: "18px" },
                        color: Colors.black,
                        mb: 2,
                        fontWeight: "400",
                        pr: { sm: 0, xs: 3 },
                        textAlign: lang == "ar" ? "center" : "left",
                      }}
                    >
                      {t("liscensed")}
                    </Typography>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        mt: 2,
                        justifyContent: lang == "ar" ? "center" : "",
                        display: lang == "ar" ? "flex" : "",
                        gap: lang == "ar" ? "8px" : "",

                      }}
                    >
                      <Box
                        component="a"
                        href="https://apps.apple.com/ae/app/scriptio-online-pharmacy/id1539857878"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          display: "inline-block",
                          transition: "transform 0.2s ease",
                          "&:hover": {
                            transform: "scale(1.05)",
                          },
                        }}
                      >
                        <Box
                          component="img"
                          src={Images.appStore}
                          alt="Download on App Store"
                          sx={{
                            height: { xs: "36px", md: "40px" },
                            width: "auto",
                            borderRadius: "8px",
                            "@media (max-width:444px)": {
                              height: "26px !important",
                            },
                          }}
                        />
                      </Box>
                      <Box
                        component="a"
                        href="https://play.google.com/store/apps/details?id=com.erxprescriptionuser&pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          display: "inline-block",
                          transition: "transform 0.2s ease",
                          "&:hover": {
                            transform: "scale(1.05)",
                          },
                        }}
                      >
                        <Box
                          component="img"
                          src={Images.googlePlay}
                          alt="Get it on Google Play"
                          sx={{
                            height: { xs: "36px", md: "40px" },
                            width: "auto",
                            borderRadius: "8px",
                            "@media (max-width:444px)": {
                              height: "26px !important",
                            },
                          }}
                        />
                      </Box>
                    </Stack>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>

          <Box bgcolor="white" borderRadius="32px 32px 0 0" pt={3}>
            <Typography
              sx={{
                color: Colors.tertiary,
                fontSize: { xs: "1.5rem", md: "2rem" },
              }}
              variant="h5"
              textAlign="center"
              fontWeight="bold"
              mb={3}
            >
              {t("categories")}
            </Typography>

            <Box
              sx={{
                p: { md: "20px", sm: "0", xs: "0" },

                height: "100%",
              }}
            >
              <Grid container spacing={2}>
                {categories.map((item, index) => (
                  <Grid
                    item
                    xs={6}
                    sm={4}
                    md={2}
                    key={index}
                    sx={{
                      display: { sm: "flex", xs: "blck" },
                      justifyContent: { sm: "center", xs: "none" },
                    }}
                  >
                    {/* <Box
                    sx={{
                      bgcolor: Colors.white,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      borderRadius: "8px",
                      boxShadow: "1px 1px 10px 1px #e4e4e4",
                      width: { md: "60%", sm: "100px" },
                      height: "100px",
                      padding: "30px",
                      gap: "20px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      handleCategoryClick(item._id, item.name, item.picture)
                    }
                  >
                    <CardMedia
                      component={"img"}
                      src={BaseUrl + item?.picture}
                      width={"50px"}
                      height={"50px"}
                      sx={{ objectFit: "contain" }}
                    />
                    <Typography
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                    >
                      {lang === "ar" ? item?.name_ar : item?.name}
                    </Typography>
                  </Box> */}
                    <Card
                      sx={{ width: "100%", height: "200px" }}
                      onClick={() => handleCategoryClick(item?._id)}
                    >
                      <CardActionArea>
                        <CardMedia
                          component="img"
                          height="140"
                          image={BaseUrl + item?.picture}
                          alt="green iguana"
                        />
                        <CardContent>
                          <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            sx={{ fontSize: "14px", textAlign: "center" }}
                          >
                            {lang === "ar" ? item?.name_ar : item?.name}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>

            <Box textAlign="center" mt={4}>
              <Button
                onClick={() => navigate("/web/marketplace/categories")}
                variant="contained"
                color="primary"
                sx={{
                  px: 6,
                  py: 1,
                  borderRadius: 1,
                  background: Colors.tertiary,
                }}
              >
                {t("viewAll")}
              </Button>
            </Box>
          </Box>
        </Box>
      ) : (
        <CardMedia
          image={Images.heroImage}
          alt="A glass jar filled with honey"
          sx={{
            width: "100%",
            // height: { xs: '350px', md: '500px' },
            height: { md: "110vh", sm: "100vh", xs: "93vh" },
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            position: "relative",
          }}
        >
          <Grid
            container
            spacing={0}
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              flexWrap: "nowrap",
              alignItems: "center",
              // justifyContent: lang === "ar" ? "flex-start" : "flex-end",
              justifyContent: "center",
            }}
          >
            <Grid
              item
              xs={12}
              md={5}
              lg={5}
              sx={{
                // p: { md: lang === "ar" ? "40px" : "8px", xs: "0px 10px" },
                marginTop: {
                  lg: lang === "ar" ? "100px !important" : "100px !important",
                  md: lang != "ar" ? "80px !important" : "130px !important",
                },
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={1}
              >
                <Box display="flex" gap={0.5}>
                  <Star sx={{ color: "#FFA826", fontSize: "25px" }} />
                  <Star sx={{ color: "#FFA826", fontSize: "25px" }} />
                  <Star sx={{ color: "#FFA826", fontSize: "25px" }} />
                  <Star sx={{ color: "#FFA826", fontSize: "25px" }} />
                  <Star sx={{ color: "#FFA826", fontSize: "25px" }} />
                </Box>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: {
                      xs: "16px",
                      sm: "18px",
                      md: "18px",
                    },
                    fontWeight: 500,
                    color: Colors.black,
                    letterSpacing: "1px",
                  }}
                >
                  {lang == "ar" ? " + 1000 " : ""}{" "}
                  <span
                    style={{
                      fontSize: {
                        xs: "16px",
                        sm: "18px",
                        md: "18px",
                      },
                      fontWeight: 700,
                      color: Colors.black,
                      letterSpacing: "1px",
                    }}
                  >
                    {" "}
                    {t("1k_download")}
                  </span>
                </Typography>
              </Box>
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: "25px", sm: "30px", md: "37px", lg: "40px" },

                  fontWeight: 800,
                  textAlign: "center",
                  color: Colors.tertiary,
                  position: "relative",
                }}
              >
                {t("deliver")}
              </Typography>
            </Grid>

            <Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  // marginTop: { md: "50px", sm: "40px" },
                  "@media (min-width:1200px)": {
                    fontSize: "14px !important",
                  },
                }}
              >
                <Box
                  sx={{
                    // position: "absolute",
                    width: { md: "50%", xs: "88%" },
                    height: "40px",
                    backgroundColor: "#F7F7F7",
                    // zIndex: "1",
                    bottom: { md: "2%", xs: "27%" },
                    p: 1,
                    display: "flex",
                    alignItems: "center",

                    borderRadius: "10px",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <TextField
                    size="medium"
                    variant="outlined"
                    type="text"
                    fullWidth
                    placeholder={t("SearchMedicines")}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch();
                      }
                    }}
                    sx={{
                      "& fieldset": { border: "none" },
                      "& input": {
                        pt: "5px",
                        pb: "5px",
                        pl: "14px",
                      },
                      "& .MuiInputBase-root": {
                        pr: "6px",
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <Button
                          variant="contained"
                          sx={{
                            background: "none !important",
                            boxShadow: "none",
                          }}
                          onClick={handleSearch}
                          startIcon={<Search />}
                        ></Button>
                      ),
                    }}
                  />
                </Box>
              </Box>
              <Grid item xs={12} md={8} lg={7} sx={{ margin: "48px auto" }}>
                <Grid container justifyContent="center" spacing={2}>
                  {categories.map((item, index) => (
                    <Grid item key={index} md={3} sm={3} xs={6}>
                      <Paper
                        elevation={1}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          borderRadius: "12px",
                          border: `1px solid  ${Colors.tertiary}`,
                          px: 1,
                          py: 1,
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          handleCategoryClick(item._id, item.name, item.picture)
                        }
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <img
                            src={BaseUrl + item?.picture}
                            alt={item?.label}
                            width={40}
                            height={50}
                            style={{ objectFit: "cover" }}
                          />
                          <Typography
                            fontWeight={500}
                            sx={{
                              fontSize: { md: "13px", sm: "13px", xs: "11px" },
                            }}
                          >
                            {" "}
                            {lang === "ar" ? item?.name_ar : item?.name}
                          </Typography>
                        </Box>
                        <Box
                          sx={{ cursor: "pointer" }}
                          onClick={() =>
                            handleCategoryClick(
                              item._id,
                              item.name,
                              item.picture
                            )
                          }
                        >
                          {lang == "ar" ? (
                            <ChevronLeft sx={{ color: "grey.500" }} />
                          ) : (
                            <ChevronRightIcon sx={{ color: "grey.500" }} />
                          )}
                        </Box>
                      </Paper>
                    </Grid>
                  ))}
                  <Grid item md={3} sm={3} xs={6}>
                    <Button
                      onClick={() => navigate("/web/marketplace/categories")}
                      variant="contained"
                      sx={{
                        backgroundColor: Colors.tertiary,
                        border: "1px solid white",
                        boxShadow:
                          "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
                        "&:hover": {
                          backgroundColor: Colors.tertiary,
                          // opacity: "0.9",
                        },
                        borderRadius: 2,
                        px: 2,
                        py: 2,
                      }}
                    >
                      {t("viewAll")}
                      <IconButton size="small">
                        {lang == "ar" ? (
                          <ChevronLeft sx={{ color: "white" }} />
                        ) : (
                          <ChevronRightIcon sx={{ color: "white" }} />
                        )}
                      </IconButton>
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </CardMedia>
      )}

      {/* ========== Video ========== */}

      {/* <Video /> */}

      {/* ========== Slider ========== */}

      {isSmallScreen ? (
        <>
          <Box>
            <Grid container spacing={2}>
              <Grid item md={12} xs={12}>
                <Container maxWidth="lg" sx={{ pt: 5 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      mb: 4,
                      textAlign: "center",
                    }}
                  >
                    <Box>
                      <Typography
                        variant="h4"
                        sx={{
                          color: Colors.tertiary,
                          fontWeight: "bold",
                          mb: 1,
                          fontSize: { xs: "1.5rem", md: "2rem" },
                        }}
                      >
                        {t("bestforless")}
                      </Typography>
                      <Typography
                        sx={{
                          color: Colors.grey3,
                          fontSize: "1rem",
                        }}
                      >
                        {t("popularinCity")}
                      </Typography>
                    </Box>
                  </Box>

                  <Box dir={lang === "ar" ? "rtl" : "ltr"}>
                    <Grid container spacing={2}>
                      {products?.slice(0, 4)?.map((item) => (
                        <Grid item xs={6} sm={6} md={3} lg={2} key={item.id}>
                          <Card
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              position: "relative",
                              border: "1px solid #dadada",
                              boxShadow: "none !important",
                              borderRadius: 3,
                              height: "100%",
                            }}
                          >
                            {/* {product.discount && (
                              <Chip
                                label={`${product.discount}%`}
                                sx={{
                                  position: "absolute",
                                  top: 8,
                                  left: 8,
                                  backgroundColor: "#f44336",
                                  color: "white",
                                  fontWeight: "bold",
                                  zIndex: 1,
                                  fontSize: "0.75rem",
                                }}
                              />
                            )} */}

                            {/* Image */}
                            <CardMedia
                              component="img"
                              src={BaseUrl + item?.picture[0]}
                              alt={item.name}
                              width={"150px"}
                              height={"150px"}
                              sx={{ objectFit: "contain", cursor: "pointer" }}
                              onClick={() =>
                                navigate(
                                  `/web/marketplace/product/${item?._id}`
                                )
                              }
                            />

                            <CardContent
                              sx={{
                                flexGrow: 1,
                                pt: item.freeDelivery ? 1 : 2,
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{
                                  mb: 2,
                                  fontSize: "0.85rem",
                                  lineHeight: 1.3,
                                  height: "2.6em",
                                  overflow: "hidden",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                }}
                              >
                                {item?.name}
                              </Typography>

                              <Box
                                sx={{
                                  mb: 2,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{
                                    textDecoration: item?.discounted_price
                                      ? "line-through"
                                      : "none",
                                    color: "text.secondary",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {t("aed")} <b>{item?.price}</b>
                                </Typography>

                                {item?.discounted_price !== 0 && (
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      color: Colors.tertiary,
                                      fontWeight: "bold",
                                      fontSize: "1rem",
                                    }}
                                  >
                                    {t("aed")} <b>{item?.discounted_price}</b>
                                  </Typography>
                                )}
                              </Box>

                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    border: "1px solid #ddd",
                                    borderRadius: 1,
                                    height: "33px",
                                    width: "80px",
                                  }}
                                >
                                  <IconButton
                                    size="small"
                                    onClick={() => handleDecrement(item)}
                                    sx={{ p: 0.5 }}
                                  >
                                    <RemoveIcon fontSize="small" />
                                  </IconButton>
                                  <TextField
                                    value={
                                      cart.find((e) => e._id === item._id)
                                        ?.qty || 0
                                    }
                                    size="small"
                                    sx={{
                                      width: "40px",
                                      "& .MuiOutlinedInput-root": {
                                        "& fieldset": { border: "none" },
                                      },
                                      "& input": {
                                        textAlign: "center",
                                        p: 0.5,
                                        fontSize: "0.875rem",
                                      },
                                    }}
                                    inputProps={{ readOnly: true }}
                                  />
                                  <IconButton
                                    size="small"
                                    onClick={() => handleIncrement(item)}
                                    sx={{ p: 0.5 }}
                                  >
                                    <AddIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                                <Button
                                  disabled={item?.in_stock === false}
                                  onClick={() => handleIncrement1(item)}
                                  sx={{
                                    backgroundColor: "#f5f5f5",
                                    p: "6px 12px",
                                    minWidth: "auto !important",
                                    "&:hover": { backgroundColor: "#e0e0e0" },
                                  }}
                                >
                                  <Cart />
                                </Button>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}

                      <Grid
                        item
                        xs={12}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          paddingRight: lang == "ar" ? "0px " : "auto",
                          mt: 3,
                        }}
                      >
                        <Button
                          onClick={() => navigate("/web/marketplace/products")}
                          variant="contained"
                          sx={{
                            backgroundColor: Colors.tertiary,
                            boxShadow:
                              "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
                            "&:hover": {
                              backgroundColor: Colors.tertiary,
                              opacity: 0.9,
                            },
                            borderRadius: 2,
                            px: 3,
                            py: 1,
                          }}
                        >
                          {t("viewAll")}
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Container>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : (
        <>
          <Box>
            <Grid
              container
              spacing={2}
              sx={
                lang === "ar"
                  ? {
                      paddingLeft: "0px !important",
                      marginLeft: "0px !important",
                    }
                  : ""
              }
            >
              <Grid
                item
                md={12}
                xs={12}
                sx={
                  lang === "ar"
                    ? {
                        paddingLeft: "0px !important",
                        marginLeft: "0px !important",
                      }
                    : ""
                }
              >
                <Container
                  maxWidth="lg"
                  sx={{ pt: 8, width: "95% !important" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      mb: 4,
                    }}
                  >
                    <Box>
                      <Typography
                        variant="h4"
                        sx={{
                          color: Colors.tertiary,
                          fontWeight: "bold",
                          mb: 1,
                          fontSize: { xs: "1.5rem", md: "2rem" },
                        }}
                      >
                        {t("bestforless")}
                      </Typography>
                      <Typography
                        sx={{
                          color: Colors.grey3,
                          fontSize: "1rem",
                        }}
                      >
                        {t("popularinCity")}
                      </Typography>
                    </Box>
                    <Button
                      onClick={() => navigate("/web/marketplace/products")}
                      variant="contained"
                      sx={{
                        backgroundColor: Colors.tertiary,
                        boxShadow:
                          "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
                        "&:hover": {
                          backgroundColor: Colors.tertiary,
                          opacity: 0.9,
                        },
                        borderRadius: 2,
                        px: 3,
                        py: 1,
                      }}
                    >
                      {t("viewAll")}
                    </Button>
                  </Box>

                  <Box
                    dir={lang === "ar" ? "ltr" : "ltr"}
                    sx={{ position: "relative", "& .swiper": { pb: 4 } }}
                  >
                    <Swiper
                      modules={[Navigation, Pagination, Autoplay]}
                      spaceBetween={16}
                      slidesPerView={1}
                      navigation={{
                        nextEl: ".swiper-button-next-custom",
                        prevEl: ".swiper-button-prev-custom",
                      }}
                      pagination={{
                        clickable: true,
                        bulletClass: "swiper-pagination-bullet-custom",
                        bulletActiveClass:
                          "swiper-pagination-bullet-active-custom",
                      }}
                      autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                      }}
                      breakpoints={{
                        640: {
                          slidesPerView: 2,
                        },
                        768: {
                          slidesPerView: 4,
                        },
                        1024: {
                          slidesPerView: 4,
                        },
                        1280: {
                          slidesPerView: 5,
                        },
                      }}
                      loop={true}
                      className="product-swiper"
                    >
                      {products.map((item) => (
                        <SwiperSlide key={item.id}>
                          <Card
                            sx={{
                              // height: {md:"360px",sm:'auto',xs:'auto'},
                              display: "flex",
                              flexDirection: "column",
                              position: "relative",
                              border: "1px solid #dadada",
                              mx: 1,
                              boxShadow: "none !important",
                              borderRadius: 3,
                              height: "315px ",
                            }}
                          >
                            {/* {item.discount && (
                              <Chip
                                label={`${item.discount}%`}
                                sx={{
                                  position: "absolute",
                                  top: 8,
                                  left: 8,
                                  backgroundColor: "#f44336",
                                  color: "white",
                                  fontWeight: "bold",
                                  zIndex: 1,
                                  fontSize: "0.75rem",
                                }}
                              />
                            )} */}

                            <CardMedia
                              component="img"
                              //   height="200"
                              src={BaseUrl + item?.picture[0]}
                              alt={item.name}
                              width={"150px"}
                              height={"150px"}
                              sx={{ objectFit: "contain", cursor: "pointer" }}
                              onClick={() =>
                                navigate(
                                  `/web/marketplace/product/${item?._id}`
                                )
                              }
                            />

                            <CardContent
                              sx={{
                                flexGrow: 1,
                                pt: item.freeDelivery ? 1 : 2,
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{
                                  mb: 2,
                                  fontSize: "0.85rem",
                                  lineHeight: 1.3,
                                  height: "2.6em",
                                  overflow: "hidden",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                }}
                              >
                                {item.name}
                              </Typography>

                              <Box
                                sx={{
                                  mb: 2,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{
                                    textDecoration: item?.discounted_price
                                      ? "line-through"
                                      : "none",
                                    color: "text.secondary",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {t("aed")} <b>{item?.price}</b>
                                </Typography>

                                {item?.discounted_price !== 0 && (
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      color: Colors.tertiary,
                                      fontWeight: "bold",
                                      fontSize: "1rem",
                                    }}
                                  >
                                    {t("aed")} <b>{item?.discounted_price}</b>
                                  </Typography>
                                )}
                              </Box>

                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    border: "1px solid #ddd",
                                    borderRadius: 1,
                                    height: "33px",
                                    width: "80px",
                                  }}
                                >
                                  <IconButton
                                    size="small"
                                    onClick={() => handleDecrement(item)}
                                    sx={{ p: 0.5 }}
                                  >
                                    <RemoveIcon fontSize="small" />
                                  </IconButton>
                                  <TextField
                                    value={
                                      cart.find((e) => e._id === item._id)
                                        ?.qty || 0
                                    }
                                    size="small"
                                    sx={{
                                      width: "40px",
                                      "& .MuiOutlinedInput-root": {
                                        "& fieldset": { border: "none" },
                                      },
                                      "& input": {
                                        textAlign: "center",
                                        p: 0.5,
                                        fontSize: "0.875rem",
                                      },
                                    }}
                                    inputProps={{ readOnly: true }}
                                  />
                                  <IconButton
                                    size="small"
                                    onClick={() => handleIncrement(item)}
                                    sx={{ p: 0.5 }}
                                  >
                                    <AddIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                                <Button
                                  disabled={item?.in_stock === false}
                                  onClick={() => handleIncrement1(item)}
                                  sx={{
                                    backgroundColor: "#f5f5f5",
                                    p: "6px 12px",
                                    minWidth: "auto !important",
                                    "&:hover": { backgroundColor: "#e0e0e0" },
                                  }}
                                >
                                  <Cart />
                                </Button>
                              </Stack>
                            </CardContent>
                          </Card>
                        </SwiperSlide>
                      ))}
                    </Swiper>

                    <Box dir={lang === "ar" ? "ltr" : "ltr"}>
                      <IconButton
                        className={
                          lang === "ar"
                            ? "swiper-button-next-custom"
                            : "swiper-button-prev-custom"
                        }
                        sx={{
                          position: "absolute",
                          left: -20,
                          top: "40%",
                          transform: "translateY(-50%)",
                          backgroundColor: Colors.tertiary,
                          color: "white",
                          "&:hover": {
                            backgroundColor: Colors.tertiary,
                            opacity: 0.9,
                          },
                          width: 40,
                          height: 40,
                          zIndex: 2,
                        }}
                      >
                        {lang === "ar" ? <ChevronRightIcon /> : <ChevronLeft />}
                      </IconButton>

                      <IconButton
                        className={
                          lang === "ar"
                            ? "swiper-button-prev-custom"
                            : "swiper-button-next-custom"
                        }
                        sx={{
                          position: "absolute",
                          right: -20,
                          top: "40%",
                          transform: "translateY(-50%)",
                          backgroundColor: Colors.tertiary,
                          color: "white",
                          "&:hover": {
                            backgroundColor: Colors.tertiary,
                            opacity: 0.9,
                          },
                          width: 40,
                          height: 40,
                          zIndex: 2,
                        }}
                      >
                        {lang === "ar" ? <ChevronLeft /> : <ChevronRightIcon />}
                      </IconButton>
                    </Box>
                  </Box>
                </Container>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {/* ========== Pharmicies ========== */}

      <Box>
        <Grid
          container
          spacing={2}
          sx={
            lang === "ar"
              ? { paddingLeft: "0px !important", marginLeft: "0px !important" }
              : ""
          }
        >
          <Grid
            item
            md={12}
            xs={12}
            sx={
              lang === "ar"
                ? {
                    paddingLeft: "0px !important",
                    marginLeft: "0px !important",
                  }
                : ""
            }
          >
            <Container maxWidth="lg" sx={{ pt: 6, width: "95% !important" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: isSmallScreen ? "center" : "space-between ",
                  alignItems: "flex-start",
                  mb: 4,
                }}
              >
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      color: Colors.tertiary,
                      fontWeight: "bold",
                      mb: 1,
                      fontSize: { xs: "1.5rem", md: "2rem" },
                    }}
                  >
                    {t("morePharmacies")}
                  </Typography>
                </Box>
                {!isSmallScreen && (
                  <Button
                    onClick={() => navigate("/web/marketplace/pharmacies")}
                    variant="contained"
                    sx={{
                      backgroundColor: Colors.tertiary,
                      boxShadow:
                        "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
                      "&:hover": {
                        backgroundColor: Colors.tertiary,
                        opacity: 0.9,
                      },
                      borderRadius: 2,
                      px: 3,
                      py: 1,
                    }}
                  >
                    {t("viewAll")}
                  </Button>
                )}
              </Box>

              {/*Pharmicis */}
              <Grid container spacing={2} sx={{ px: 2 }}>
                {pharmacies.map((product, index) => (
                  <Grid item xs={6} sm={4} md={2} key={index}>
                    <Card
                      sx={{
                        height: 130,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "none !important",
                      }}
                    >
                      <CardMedia
                        onClick={() =>
                          handlePharmacyClick(
                            product._id,
                            product?.name,
                            product.picture
                          )
                        }
                        component="img"
                        image={BaseUrl + product.picture}
                        alt={product.name}
                        sx={{
                          maxHeight: "100%",
                          maxWidth: "100%",
                          objectFit: "contain",
                          cursor: "pointer",
                        }}
                      />
                    </Card>
                  </Grid>
                ))}
              </Grid>

              {isSmallScreen && (
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center", mt: 5 }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: Colors.tertiary,
                      boxShadow:
                        "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
                      "&:hover": {
                        backgroundColor: Colors.tertiary,
                        opacity: 0.9,
                      },
                      borderRadius: 2,
                      px: 3,
                      py: 1,
                    }}
                    onClick={() => navigate("/web/marketplace/pharmacies")}
                  >
                    {t("viewAll")}
                  </Button>
                </Grid>
              )}
            </Container>
          </Grid>
        </Grid>
      </Box>

      {/* ==========  App Features ==========*/}

      <Box sx={{ py: { md: "80px", xs: "60px" } }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: { md: 8, xs: 6 } }}>
            <Typography
              variant="h3"
              sx={{
                fontSize: { xs: "28px", md: "36px" },
                fontWeight: "600",
                color: Colors.tertiary,
                mb: 2,
              }}
            >
              {t("appFeature")}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: "14px", md: "16px" },
                color: "#6c757d",
                maxWidth: "600px",
                mx: "auto",
                lineHeight: 1.6,
              }}
            >
              {t("featrueDescription")}
            </Typography>
          </Box>

          <Grid
            container
            spacing={4}
            alignItems="center"
            dir={lang === "ar" ? "ltr" : "ltr"}
          >
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  mt: { md: "0px", xs: "0px" },
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  component={"img"}
                  src={Images.appMockImg1}
                  sx={{
                    width: { lg: "auto", md: "auto", sm: "100%", xs: "100%" },
                    height: { md: "600px", xs: "auto" },
                  }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Grid container spacing={3}>
                {features.map((feature) => (
                  <Grid item xs={12} sm={6} key={feature.id}>
                    <Card
                      sx={{
                        height: "100%",
                        border: "1px solid #e9ecef",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                        borderRadius: "12px",
                        transition: "all 0.3s ease",
                        px: 3,
                        "&:hover": {
                          boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                          transform: "translateY(-2px)",
                          border: `2px solid ${Colors.tertiary}`,
                        },
                      }}
                    >
                      <CardContent sx={{ p: 3, textAlign: "center" }}>
                        <Stack
                          spacing={2}
                          alignItems="center"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            textAlign: "left",
                          }}
                        >
                          <Box sx={{ width: "100%" }}>{feature.icon}</Box>

                          <Typography
                            variant="h6"
                            sx={{
                              fontSize: "16px",
                              fontWeight: "600",
                              color: Colors.tertiary,
                              lineHeight: 1.3,
                              textAlign: "left",
                              width: "100%",
                            }}
                          >
                            {feature.title}
                          </Typography>

                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "14px",
                              color: "#6c757d",
                              lineHeight: 1.5,
                              textAlign: "left",
                            }}
                          >
                            {feature.description}
                          </Typography>
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* ========== Download App ==========*/}

      {/* {!isSmallScreen && ( */}
      <Box sx={{ py: { md: "70px", xs: "60px" } }}>
        <Container maxWidth="lg">
          <Box
            sx={{
              background: Colors.tertiary,
              borderRadius: "24px",

              position: "relative",
              minHeight: { md: "450px", sm: "550px", xs: "550px" },
            }}
          >
            <Grid container spacing={0} sx={{ height: "100%", pb: 2 }}>
              <Grid item xs={12} md={7}>
                <Box
                  sx={{
                    p: { md: 6, xs: 4 },
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Box sx={{ mb: 3 }}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {[1, 2, 3, 4, 5].map((star) => (
                          <StarIcon
                            key={star}
                            sx={{
                              color: "#FFA826",
                              fontSize: "20px",
                            }}
                          />
                        ))}
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "rgba(255, 255, 255, 0.9)",
                          fontSize: "16px",
                          fontWeight: "500",
                          ml: "0px !important",
                        }}
                      >
                        {lang == "ar" ? " + 1000 " : "1k+"}{" "}
                        {t("1k_download_worldWide")}
                      </Typography>
                    </Stack>
                  </Box>

                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: { xs: "32px", md: "48px" },
                      fontWeight: "700",
                      color: "white",
                      lineHeight: 1.2,
                      mb: 2,
                      textTransform: "uppercase",
                      letterSpacing: "2px",
                    }}
                  >
                    {t("deliver")}
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: "13px", md: "26px" },
                      color: "rgba(255, 255, 255, 0.9)",
                      mb: 2,
                      fontWeight: "400",
                    }}
                  >
                    {t("liscensed")}
                  </Typography>

                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={2}
                    sx={{
                       mt: { md: 2, xs: 1 } ,
                    flexDirection: "row !important",
                    alignItems: "center",
                    gap:1
                  }}
                  >
                    <Box
                      component="a"
                      href="https://apps.apple.com/ae/app/scriptio-online-pharmacy/id1539857878"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        display: "inline-block",
                        transition: "transform 0.2s ease",
                        "&:hover": {
                          transform: "scale(1.05)",
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src={Images.appStore}
                        alt="Download on App Store"
                        sx={{
                          height: { md: "45px", xs: "40px" },
                          width: "auto",
                          borderRadius: "8px",
                        }}
                      />
                    </Box>
                    <Box
                      component="a"
                      href="https://play.google.com/store/apps/details?id=com.erxprescriptionuser&pli=1"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        display: "inline-block",
                        transition: "transform 0.2s ease",
                        mt:"0px !important",
                        "&:hover": {
                          transform: "scale(1.05)",
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src={Images.googlePlay}
                        alt="Get it on Google Play"
                        sx={{
                          height: { md: "45px", xs: "40px" },
                          width: "auto",
                          borderRadius: "8px",
                        }}
                      />
                    </Box>
                  </Stack>
                </Box>
              </Grid>

              <Grid item xs={12} md={5}>
                <Box
                  sx={{
                    height: "100%",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: { md: 2, xs: 4 },
                  }}
                >
                  <Box
                    component={"img"}
                    src={Images.appMockImg2}
                    sx={{
                      height: { md: "470px", xs: "330px" },
                      position: { md: "absolute", sm: "static" },
                      bottom: "30px",
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
      {/* // )} */}

      {/* ========== Feedbacks ==========*/}

      <Box sx={{ py: { md: "80px", xs: "60px" } }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: { md: 6, xs: 4 } }}>
            <Typography
              variant="h3"
              sx={{
                fontSize: { xs: "24px", md: "30px" },
                fontWeight: "600",
                color: Colors.tertiary,
                lineHeight: 1.3,
                // maxWidth: "600px",
                mx: "auto",
              }}
            >
              {t("whatClientSay")}
            </Typography>
          </Box>

          <Box sx={{ position: "relative", maxWidth: "800px", mx: "auto" }}>
            <Swiper
              key={lang}
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              navigation={{
                nextEl: ".testimonials-button-next",
                prevEl: ".testimonials-button-prev",
              }}
              pagination={{
                clickable: true,
                bulletClass: "testimonials-pagination-bullet",
                bulletActiveClass: "testimonials-pagination-bullet-active",
                el: ".testimonials-pagination-container",
              }}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              className="testimonials-swiper"
            >
              {testimonials.map((testimonial) => (
                <SwiperSlide key={testimonial.id}>
                  <Card
                    sx={{
                      background: Colors.tertiary,
                      borderRadius: "16px",
                      height: "200px",
                      overflow: "hidden",
                    }}
                  >
                    <CardContent
                      dir={"ltr"}
                      sx={{
                        p: { md: 4, xs: 3 },
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "150px",
                      }}
                    >
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={3}
                        alignItems="center"
                      >
                        {/* <Avatar
                          src={testimonial.image}
                          alt={testimonial.name}
                          sx={{
                            width: "auto",
                            height: "auto",
                            // width: { md: 80, xs: 70 },
                            // height: { md: 80, xs: 70 },
                            border: "3px solid rgba(255, 255, 255, 0.3)",
                            flexShrink: 0,
                          }}
                        /> */}

                        <Box
                          sx={{
                            flex: 1,
                            textAlign: { xs: "left", sm: "left" },
                          }}
                        >
                          {/* <Typography
                            variant="h6"
                            sx={{
                              color: "white",
                              fontWeight: "600",
                              fontSize: { xs: "18px", md: "20px" },
                              mb: 2,
                            }}
                            dir={lang == "ar" ? "ltr" : "ltr"}
                          >
                            {testimonial.name}
                          </Typography> */}

                          <Typography
                            dir={"ltr"}
                            variant="body1"
                            sx={{
                              color: "rgba(255, 255, 255, 0.95)",
                              fontSize: { xs: "16px", md: "20px" },
                              lineHeight: 1.6,
                              fontStyle: "italic",
                              textAlign: lang == "ar" ? "right" : "left",
                            }}
                            // dir={lang == "ar" ? "rtl !important" : "ltr"}
                          >
                            "{testimonial.review}"
                          </Typography>

                          {/* <Box
                            sx={{
                              mt: 2,
                              display: "flex",
                              justifyContent: {
                                xs: "center",
                                sm: "flex-start",
                              },
                              color: Colors.white,
                            }}
                            dir={lang == "ar" ? "ltr" : "ltr"}
                          >
                            {testimonial?.date}
                          </Box> */}
                        </Box>
                      </Stack>
                    </CardContent>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: 4,
                gap: 1,
              }}
            >
              {/* Prev Button */}
              <Box
                className="testimonials-button-prev"
                sx={{
                  width: { md: 60, xs: 40 },
                  height: { md: 60, xs: 40 },
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                {lang === "ar" ? (
                  <ChevronRightIcon
                    sx={{ color: "#5ba3d4", fontSize: { md: 34, xs: 25 } }}
                  />
                ) : (
                  <ChevronLeft
                    sx={{ color: "#5ba3d4", fontSize: { md: 34, xs: 25 } }}
                  />
                )}
              </Box>

              <Box
                className="testimonials-pagination-container"
                sx={{ mx: 2, width: "50% !important" }}
              />

              {/* Next Button */}
              <Box
                className="testimonials-button-next"
                sx={{
                  width: { md: 50, xs: 40 },
                  height: { md: 50, xs: 40 },
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                {lang === "ar" ? (
                  <ChevronLeft
                    sx={{ color: "#5ba3d4", fontSize: { md: 34, xs: 25 } }}
                  />
                ) : (
                  <ChevronRightIcon
                    sx={{ color: "#5ba3d4", fontSize: { md: 34, xs: 25 } }}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>
    </Fragment>
  );
}

export default Home;
